import { companyPartialUpdaterBuilder } from "../companyPartialUpdaterBuilder";
import {
  ProfilesVisibilityFormik,
  PROFILE_VISIBILITY_MESSENGER_CONTEXT,
  validationProfilesVisibilitySectionSchema,
} from "./ProfileVisibilityForm";

export const ProfileVisibilityEdit = companyPartialUpdaterBuilder(ProfilesVisibilityFormik, {
  validationSchema: validationProfilesVisibilitySectionSchema,
  messengerContext: PROFILE_VISIBILITY_MESSENGER_CONTEXT,
});
